import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const DoubleArrowDown = ({ width = 14, height = 14, color = "#F5223E" }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M17.5019 8.73242L10.0019 16.2324L2.50187 8.73242L0.734375 10.4999L9.11812 18.8837C9.35253 19.118 9.67042 19.2497 10.0019 19.2497C10.3333 19.2497 10.6512 19.118 10.8856 18.8837L19.2694 10.4999L17.5019 8.73242Z"
        fill={color}
      />
      <path
        d="M17.5019 1.23242L10.0019 8.73242L2.50187 1.23242L0.734375 2.99992L9.11812 11.3837C9.35253 11.618 9.67042 11.7497 10.0019 11.7497C10.3333 11.7497 10.6512 11.618 10.8856 11.3837L19.2694 2.99992L17.5019 1.23242Z"
        fill={color}
      />
    </svg>
  );
};

export default DoubleArrowDown;
